export async function fetchCsrf() {
  const csrfTokenURL = new URL(document.body.dataset.docRootUrl)
  csrfTokenURL.pathname += "/csrf_meta_tags.html"
  const existingCsrfToken = document.querySelector("meta[name='csrf-token']")

  if (csrfTokenURL && !existingCsrfToken) {
    const textResponse = await fetch(csrfTokenURL)
      .then(response => response.text())

    if (textResponse) {
      // Store CSRF token in <meta> head elements (that's how Rails does
      // it when the page is generated by the backend) in order for
      // future form submissions to use the token
      document.head.insertAdjacentHTML("beforeend", textResponse)

    }
  }

  return document.querySelector("meta[name='csrf-token']")?.content
}
